// 9fbef606107a605d69c0edbcd8029e5d

const drawCircle = (ctx, size, colors) => {
  ctx.beginPath();
  ctx.arc(size, size, size, 0, 2 * Math.PI);
  ctx.fillStyle = colors;
  ctx.fill();
};

export default drawCircle;
